/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Not_Found_TitleInputs */

const en_users_not_found_title = /** @type {(inputs: Users_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User not found`)
};

const pt_br2_users_not_found_title = /** @type {(inputs: Users_Not_Found_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário não encontrado`)
};

/**
* | output |
* | --- |
* | "User not found" |
*
* @param {Users_Not_Found_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_not_found_title = /** @type {((inputs?: Users_Not_Found_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Not_Found_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_not_found_title(inputs)
	return pt_br2_users_not_found_title(inputs)
});